<template>
  <div class="item">
    <div class="title item-title">
      <span>{{title}}</span>
    </div>
    <div class="item-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Item',
  props: {
    title: String
  }
}
</script>

<style scoped lang="less">
@import "../common";
.item {
  padding: @padding @padding4x;
  .item-title {
    border-bottom: 1px solid black;
    span {
      line-height: 2;
    }
  }
  .item-content {
  }
}
</style>
